// Api End Point
export const URL = 'environment/'

// State Configuration
export const MODEL = 'Environment'

// Model Properties
export const PROP_HEFTY_SELECTED_FARM = 'hfty-selected-farm'
export const PROP_HEFTY_SELECTED_SEASON = 'hfty-selected-season'
export const PROP_ID = 'id'
export const PROP_ENVIRONMENT_ID = PROP_ID
export const PROP_KEY = 'key'
export const PROP_VALUE = 'value'
export const PROP_CLIENT = 'client'
